import { render, staticRenderFns } from "./mediumDialog.vue?vue&type=template&id=e35b8712&scoped=true"
import script from "./mediumDialog.vue?vue&type=script&lang=js"
export * from "./mediumDialog.vue?vue&type=script&lang=js"
import style0 from "./mediumDialog.vue?vue&type=style&index=0&id=e35b8712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35b8712",
  null
  
)

export default component.exports